import { createReducer } from '@reduxjs/toolkit';
import { commonActions } from './actions';
import { CommonState } from './types';

const initialState: CommonState = {
  networkState: 'unknown',
  sideMenuOpen: false,
};

export const commonReducer = createReducer(initialState, builder =>
  builder
    .addCase(commonActions.networkStateChanged, (state, action) => {
      state.networkState = action.payload.networkState;
    })
    .addCase(commonActions.toggleSideMenu, state => {
      state.sideMenuOpen = !state.sideMenuOpen;
    })
    .addDefaultCase(state => state),
);
